import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Forum.css';

// Import the event images
import agrifoodImg from '../../assets/images/event-agrifood.png';
import globalGrainImg from '../../assets/images/event-global-grain.png';

const eventsData = {
  featured: {
    image: agrifoodImg,
    title: 'AGRIFOOD NEXTGEN BUSINESS LEADERS SUMMIT',
    date: '12th & 13th December 2025',
    venue: 'Hyatt | Alila Diwa Goa',
    description: 'Transforming Legacy into Global Leadership. A pivotal event driving India\'s economic growth, contributing significantly to the country\'s GDP. The outlook for the Indian AgriFood industry remains strong, driven by rising demand in key sectors such as food processing, export, and technology integration.'
  },
  upcoming: [
    {
      image: globalGrainImg,
      title: 'G2F2 GLOBAL GRAIN FOOD & FEED 2025',
      date: '12th & 13th December 2025',
      venue: 'Hyatt | Alila Diwa Goa'
    },
  ]
};

const Forum = () => {
  const [activeTab, setActiveTab] = useState('Events');

  const renderContent = () => {
    // ... (renderContent function remains the same, no changes needed inside)
    switch (activeTab) {
      case 'Events':
        return (
          <div className="events-layout">
            <div className="featured-event">
              <img src={eventsData.featured.image} alt={eventsData.featured.title} className="featured-image" />
              <h3>{eventsData.featured.title}</h3>
              <p className="event-details">
                <strong>Date:</strong> {eventsData.featured.date}<br />
                <strong>Venue:</strong> {eventsData.featured.venue}
              </p>
              <p className="event-description">{eventsData.featured.description}</p>
            </div>
            <div className="upcoming-events-list">
              {eventsData.upcoming.map((event, index) => (
                <div key={index} className="upcoming-event-item">
                  <img src={event.image} alt={event.title} className="upcoming-image" />
                  <div className="upcoming-event-details">
                    <h4>{event.title}</h4>
                    <p>
                      <strong>Date:</strong> {event.date}<br />
                      <strong>Venue:</strong> {event.venue}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      case 'Webinars':
        return <p className="placeholder-text">Webinars coming soon.</p>;
      case 'Podcasts':
        return <p className="placeholder-text">Podcasts coming soon.</p>;
      default:
        return null;
    }
  };

  return (
    <section className="forum-section">
      {/* This new wrapper creates the "frame" */}
      <div className="forum-wrapper">
        <div className="section-header">
          <h2>The CRISHI Forum</h2>
          <div className="header-line"></div>
        </div>
        <p className="section-subtitle">
          A global community of thought leaders and businesses in agriculture.
        </p>

        <div className="tabs-container">
          <button onClick={() => setActiveTab('Events')} className={activeTab === 'Events' ? 'active' : ''}>Events</button>
          <button onClick={() => setActiveTab('Webinars')} className={activeTab === 'Webinars' ? 'active' : ''}>Webinars</button>
          <button onClick={() => setActiveTab('Podcasts')} className={activeTab === 'Podcasts' ? 'active' : ''}>Podcasts</button>
        </div>

        <div className="tab-content">
          {renderContent()}
        </div>

        <div className="explore-more-container">
          <Link to="/Events">
            <button className="explore-more-btn">Explore more</button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Forum;